export default function LoaderRequestsGrid() {
    return (
      <div className="grid grid-cols-12 gap-2">
        {[...Array(32)].map((_, index) => (
          <div
            key={index}
            className="flex flex-col h-40 col-span-12 animate-pulse md:col-span-6 lg:col-span-4 xl:col-span-3"
          >
            <div className="relative flex flex-col w-full bg-white border-2 h-28 border-muted-500"></div>
          </div>
        ))}
      </div>
    )
  }
  
  